import React from 'react'
import { withTranslation } from 'react-i18next'
import './styles.scss'

const baseClass = 'graph-empty'

const ActivityStatsEmpty = ({ t, imagePath, proTrackWithLevelName }) => (
  <div className={baseClass}>
    <div className={`${baseClass}__title`}>{proTrackWithLevelName}</div>
    <img src={imagePath} className={`${baseClass}__image`} alt="Not started" />
    <div className={`${baseClass}__description`}>{t(`journey`)}</div>
  </div>
)

export default withTranslation('user')(ActivityStatsEmpty)
